jQuery(document).ready(function($) {
	
	/* Recipes Book - BEGIN */
		var recipesBook = $(".recipes-book .listing");

		recipesBook.addClass("owl-carousel").owlCarousel({
			items: 1,
			margin: 0,
			dots: true,
			loop: true,
			autoplay: 5000
		});
	/* Recipes Book - END */
	
});